/**
* @name: portal-more-sel
* @author: weiyong
* @date: 2023-05-12 23:12
* @description：portal-more-sel
* @update: 2023-05-12 23:12
*/
<template>
  <div class="more-icon-div flex-div" @click="showDropEvent" v-if="workSpaceList&&workSpaceList.length>3">
    <div class="workbench-item um-box-center  flex-div" v-if="curOtherItem"
         :class="curOtherItem.id===curActiveKey?'workbench-active':'workbench-not-active'">
<!--      <img-->
<!--        src="https://design.yonyoucloud.com/static/ucf/iuap-apcom-workbench.app-fe/20230422-035041/img/w1-5564713d.png">-->
      <div class="workbench-item-label">{{ curOtherItem.label||curOtherItem.name }}</div>

      <div style="padding: 0 4px">
        <i class="more-icon remix-icon  ri-more-fill"></i>
      </div>
    </div>
    <div v-else>
      <i class="more-icon remix-icon  ri-more-fill"></i>
    </div>

    <div class="more-icon-div-drop" v-show="showDropFlag">
      <div class="wui-dropdown-menu-match-trigger roleTitleWorkbench--1ybtc">
        <ul class="wui-menu wui-menu-root wui-menu-vertical wui-menu-light">
          <template v-for="(item,index) in workSpaceList">
            <li v-if="index<3" @click.stop="emitTopItem(item)" class="wui-menu-item wui-menu-item-only-child flex-div-bet ">
              <div class="um-box-item um-box-vc flex-div">
                <i
                  class="iconfont font_family_u8c__iconfont___2OzrA icon-tuodong__iconfont___1yf59 md__index___3HmlR "></i>
<!--                <img-->
<!--                  src="https://design.yonyoucloud.com/static/ucf/iuap-apcom-workbench.app-fe/20230422-035041/img/w1-5564713d.png">-->
                <div class="defaultPortalName maxwidth" :title="item.label||item.name">{{ item.label||item.name }}</div>
                <div class="curr" v-if="index===0">
                  默认
                </div>
              </div>
              <div class="check-icon" v-show="curActiveKey===item.id?true:false" style="padding-right: 22px;display: flex;align-items: center">
                <check-outlined />
              </div>
            </li>

            <li v-if="index===3">
              <div class="divider-xm um-box-center" style="background-color: #FFF;z-index: 999;position: relative;"><span></span><p>更多工作台</p></div>
            </li>

            <li @click.stop="activeOtherCur(item)"  v-if="index>=3" class="wui-menu-item wui-menu-item-only-child flex-div-bet">
              <div class="um-box-item um-box-vc flex-div">
                <i
                  class="iconfont font_family_u8c__iconfont___2OzrA icon-tuodong__iconfont___1yf59 md__index___3HmlR "></i>
<!--                <img-->
<!--                  src="https://design.yonyoucloud.com/static/ucf/iuap-apcom-workbench.app-fe/20230422-035041/img/w1-5564713d.png">-->
                <div class="defaultPortalName maxwidth" :title="item.label||item.name">{{ item.label||item.name }}</div>
                <div class="curr"  v-if="curActiveKey===item.id"  title="" date-for-wui-tooltip="wui-tooltip-rtlmk2on2e">默认
                </div>
              </div>
              <div class="check-icon" v-show="curActiveKey===item.id?true:false" style="padding-right: 22px;display: flex;align-items: center">
                <check-outlined />
              </div>
            </li>

          </template>
        </ul>

      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "portal-more-sel",
});
</script>

<script lang="ts" setup>
import {CheckOutlined} from '@ant-design/icons-vue'
const curOtherItem: any = ref();
const props=defineProps({
  workSpaceList:{},
  curActiveKey: {},
  curSelItem:{},
});
const {curSelItem,workSpaceList}:any=toRefs(props);
const showDropFlag =ref(false);
const showDropEvent = () => {
  showDropFlag.value=true;
}
watch(curSelItem,function (newVal){
  nextTick(()=>{
    const index=unref(workSpaceList).findIndex(item=>{return item.id===newVal.id});
    if(index>=3&&curOtherItem.value==null){
      curOtherItem.value=newVal;
    }
  })
})


/**
 * 点击了不是panel里面的元素 则关闭
 * @param event
 */
const clickBody = (event) => {
  const isNotSectionCtl = event.target.closest('.more-icon-div') || event.target.closest('.more-icon-div-drop');
  if (!isNotSectionCtl) {
    showDropFlag.value=false;
  }
}

onBeforeUnmount(()=>{
  document.removeEventListener('click',clickBody)
})

onMounted(()=>{
  document.addEventListener('click',clickBody)
})

const closeSelItem=function (){
  curOtherItem.value=null;
  showDropFlag.value=false;
}
defineExpose({closeSelItem});

const emits=defineEmits(['setActiveKey','selSpaceItemFun']);
/**
 * 选择前三个
 * @param item
 */
const emitTopItem=function (item){
  emits('setActiveKey',{item});
  emits('selSpaceItemFun',item,false);
  nextTick(()=>{
    showDropFlag.value=false;
  })
}

/**
 * 选择后面的更多
 * @param item
 */
const activeOtherCur=function (item){
  curOtherItem.value=item;
  emits('setActiveKey',{item});
  emits('selSpaceItemFun',item,true);
  nextTick(()=>{
    showDropFlag.value=false;
  })
}
</script>

<style type="text/css" lang="less">
.curr {
  display: block;
  font-size: 12px;
  color: #ee2223;
  line-height: 14px;
  height: 16px;
  text-align: center;
  margin-left: 8px;
  background: rgba(238,34,35,.08);
  border-radius: 2px;
  border: 1px solid #ee2223;
  padding: 0 4px;
}
</style>
